<template>
  <div
    class="flex gap-5">
    <IconCount
      :background-color="'var(--v-secondary__green_approved-base)'"
      class="indicator-item"
      :class="{'is-clickable': isClickable, 'is-active': isClickable && filterState.includes('success')}"
      :count="countGreen"
      data-qa="offer-requirement-item_accepts"
      icon="accept"
      position="left"
      @click.stop="changeState('success')"/>
    <IconCount
      :background-color="'var(--color-warning)'"
      class="indicator-item"
      :class="{'is-clickable': isClickable, 'is-active': isClickable && filterState.includes('warning')}"
      :count="countNotYellow"
      data-qa="offer-requirement-item_not_verified"
      icon="info"
      position="left"
      @click.stop="changeState('warning')"/>
    <IconCount
      :background-color="'var(--color-error)'"
      class="indicator-item"
      :class="{'is-clickable': isClickable, 'is-active': isClickable && filterState.includes('error')}"
      :count="countNotRed"
      data-qa="offer-requirement-item_not_verified"
      icon="cancel"
      position="left"
      @click.stop="changeState('error')"/>
  </div>
</template>
<script>
import IconCount from 'components/common/elements/IconCount.vue'

export default {
  name: 'OfferRequirementIndicators',
  data() {
    return {}
  },
  methods: {
    changeState(type) {
      if (!this.isClickable) {
        return
      }

      let result = [...this.filterStateMutable]

      if (result.includes(type)) {
        result = result.filter(v => v !== type)
      } else {
        result.push(type)
      }
      this.filterStateMutable = result
    },
  },
  computed: {
    filterStateMutable: {
      get() {
        return this.filterState ?? []
      },
      set(value) {
        this.$emit('update:filterState', value)
      }
    },
    countGreen() {
      if (!this.requirements) {
        return 0
      }
      return this.requirements
        .filter(r => r.assessment === 'COMPLIES').length
    },
    countNotYellow() {
      if (!this.requirements) {
        return 0
      }
      return this.requirements
        .filter(r => ['PARTIAL', 'NOT_DETERMINED'].includes(r.assessment)).length
    },
    countNotRed() {
      if (!this.requirements) {
        return 0
      }
      return this.requirements
        .filter(r => ['NO', 'CRITICAL_NO'].includes(r.assessment))
        .length
    }
  },
  components: {
    IconCount
  },
  created() {},
  props: {
    requirements: {
      type: Array,
    },
    isClickable: {
      type: Boolean,
    },
    filterState: {
      type: Array,
    }
  },
}
</script>
<style scoped lang="scss">
.indicator-item {
  margin-right: 0 !important;
  margin-top: auto;
  height: 20px;
  &.is-active {
    box-shadow: inset 4px 4px 8px rgba(0, 0, 0, 0.2), inset -4px -4px 8px rgba(255, 255, 255, 0.7) !important;
  }
  &.is-clickable {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover,
    &:focus {
      box-shadow: inset 4px 4px 8px rgba(0, 0, 0, 0.2), inset -4px -4px 8px rgba(255, 255, 255, 0.7) !important;
    }
  }
}
</style>
